import { MasterDetailListEntry } from "@sdbn/common";

export class TruckGroup implements MasterDetailListEntry {
  id: number;
  name: string;
  priority: number;
  trucks = new Array<Truck>();
  conditions = new Array<TruckGroupGateCondition>();

  constructor(data?: Partial<TruckGroup>) {
    if (data != null) {
      this.id = data.id;
      this.name = data.name;
      this.priority = data.priority;
      if (data.conditions != null) {
        for (const condition of data.conditions) {
          this.conditions.push(condition)
        }
      }
      if (data.trucks != null) {
        for (const truck of data.trucks) {
          this.trucks.push(truck)
        }
      }
    }
  }

  public get childs(): MasterDetailListEntry[] {
    return null;
  }

  public get groupIdentifier(): string {
    return null;
  }

  public get listTitle(): string {
    return this.name;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return null;
  }
}


export class TruckGroupCondition { }

export class TruckGroupGateCondition extends TruckGroupCondition {
  id: number;
  inclusions = new Array<number>;
  exclusions = new Array<number>;

  constructor(data?: Partial<TruckGroupGateCondition>) {
    super()
    if (data != null) {
      this.id = data.id;
      if (data.inclusions != null) {
        for (const inclusion of data.inclusions) {
          this.inclusions.push(inclusion);
        }
      }
      if (data.exclusions != null) {
        for (const exclusion of data.exclusions) {
          this.exclusions.push(exclusion);
        }
      }
    }
  }
}


export class Truck {
  id: number;
  numberPlate: string;
  numberPlateOptimized: string;


  constructor(data?: Partial<Truck>) {
    if (data != null) {
      this.id = data.id;
      this.numberPlate = data.numberPlate;
      this.numberPlateOptimized = this.numberPlateOptimized;
    }
  }
}

export class Station {
  id: number;
  identifier: string;
  name: string;

  constructor(data?: Partial<Station>) {
    if (data != null) {
      this.id = data.id;
      this.name = data.name;
      this.identifier = data.identifier;
    }
  }
}
